import { render, staticRenderFns } from "./CreateBoard.vue?vue&type=template&id=4e33fe94&scoped=true&"
import script from "./CreateBoard.vue?vue&type=script&lang=js&"
export * from "./CreateBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33fe94",
  null
  
)

export default component.exports